import script from "./TressCheckboxInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./TressCheckboxInput.vue?vue&type=script&lang=ts&setup=true"

import "./TressCheckboxInput.vue?vue&type=style&index=0&id=5c30a8cd&lang=scss"

const __exports__ = script;

export default __exports__